import { useQuery } from '@tanstack/react-query';

import requestQueries from '@carers/views/Requests/utils/requestQueryFactory';

const useGetRequest = (id: string) => useQuery(requestQueries.detail(id));

export default useGetRequest;
